/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Loud_Newt_PullInputs */

const en_kind_loud_newt_pull = /** @type {(inputs: Kind_Loud_Newt_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete failed`)
};

const de_kind_loud_newt_pull = /** @type {(inputs: Kind_Loud_Newt_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Delete failed" |
*
* @param {Kind_Loud_Newt_PullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_loud_newt_pull = /** @type {((inputs?: Kind_Loud_Newt_PullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Loud_Newt_PullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_loud_newt_pull(inputs)
	return de_kind_loud_newt_pull(inputs)
});